import React, { useState } from 'react'
import SmartGrid from '@alejandro.devop/bootstrap-smart-grid'
import Panel from '@core/panel'
import { useTranslate } from '@core/hooks'
import { DictionaryKeyType } from '@core/translation-provider/translation.types'
import config from './grid.config'
import { TrikoDetail } from 'components'
import PerfectScrollbar from 'react-perfect-scrollbar'

const RegisteredTrikos: React.FC = () => {
    const t = useTranslate('trikos')
    const [selectedTriko, setSelectedTriko] = useState<any>()
    const handleActionCall = (action: string, record: { id: any }) => {
        if (action === 'view') {
            setSelectedTriko(record.id)
        }
    }
    return (
        <>
            <Panel title="registered_trikos">
                <PerfectScrollbar>
                    <SmartGrid
                        headerTextProcessor={(k: string) => t(k as DictionaryKeyType)}
                        textProcessor={(k: string, replacements) => {
                            const { key, value } = replacements || {}
                            const valuesToReplace = {}
                            if (key) {
                                valuesToReplace[key] = value
                            }
                            return t(k as DictionaryKeyType, {
                                ignoreScope: true,
                                replacements: valuesToReplace
                            })
                        }}
                        config={config}
                        onAcctionCalled={handleActionCall}
                    />
                </PerfectScrollbar>
            </Panel>
            {Boolean(selectedTriko) && (
                <TrikoDetail trikoId={selectedTriko} onClose={() => setSelectedTriko(null)} />
            )}
        </>
    )
}

export default RegisteredTrikos
